module.exports = __webpack_public_path__ + "img/MARITIMEBANK.31af71c9.svg";